// Case Buddy domain module generated from CaseBuddyCore.js.
// Spreadsheet-shaped rows remain the source of truth.
import {
  WORKFLOW_SIGNAL_ADDRESS_FLOW_COLORS_APPLIED,
  WORKFLOW_SIGNAL_ADDRESS_LEGEND_REVIEWED,
  WORKFLOW_SIGNAL_ADDENDUM_RECIPIENTS_RESOLVED,
  WORKFLOW_SIGNAL_ADDENDUM_REVIEWED,
  WORKFLOW_SIGNAL_CASE_CONCLUSION_REVIEWED,
  WORKFLOW_SIGNAL_CASE_FLOW_VISUALS_CREATED,
  WORKFLOW_SIGNAL_DEPOSIT_HOT_WALLET_NOTES_NORMALIZED,
  WORKFLOW_SIGNAL_DEPOSIT_PATTERNS_REVIEWED,
  WORKFLOW_SIGNAL_DORMANT_ADDRESS_DELIVERABLES_REVIEWED,
  WORKFLOW_SIGNAL_DUPLICATE_HASHES_LABELED,
  WORKFLOW_SIGNAL_EXCHANGE_ADDRESS_TABLE_REVIEWED,
  WORKFLOW_SIGNAL_FULL_REPORT_PACKAGE_REVIEWED,
  WORKFLOW_SIGNAL_KNOWN_ENTITY_CASING_REVIEWED,
  WORKFLOW_SIGNAL_MAIN_ENTRIES_DATED_AND_ORDERED,
  WORKFLOW_SIGNAL_MAIN_ENTRIES_ORDERED_BY_DATE,
  WORKFLOW_SIGNAL_MAIN_TRANSACTION_PATH_LABELS_ASSIGNED,
  WORKFLOW_SIGNAL_NEW_ENTITIES_REVIEWED,
  WORKFLOW_SIGNAL_NOTE_HASH_PATH_LABEL_REWRITE_COMPLETE,
  WORKFLOW_SIGNAL_PATH_ENDING_ROWS_REVIEWED,
  WORKFLOW_SIGNAL_PATH_OPERATION_RESOLVED,
  WORKFLOW_SIGNAL_REPORT_BODY_REVIEWED,
  WORKFLOW_SIGNAL_SUSPICIOUS_ADDRESS_TABLE_REVIEWED,
  WORKFLOW_SIGNAL_TEMPLATE_DELIVERABLE_REVIEWED,
  WORKFLOW_SIGNAL_TO_ADDRESS_ATTRIBUTION_APPLIED,
  WORKFLOW_SIGNAL_TOOL_68_MAIN_DATA_PREPARED,
  WORKFLOW_SIGNAL_TRANSACTION_DATES_FILLED,
  WORKFLOW_SIGNAL_TRANSACTION_NETWORKS_IDENTIFIED,
  WORKFLOW_SIGNAL_WHAT_WENT_WHERE_REVIEWED,
  WORKFLOW_SIGNAL_WWW_USD_REFERENCES_REVIEWED
} from './CaseBuddyAppConstants.js';

export function workflowAction(id, label, options = {}) {
  return {
    id,
    label,
    kind: options.kind || 'tool-slot',
    target: options.target || '',
    primary: !!options.primary,
    disabled: !!options.disabled,
    emphasis: options.emphasis || '',
    signalCode: options.signalCode || ''
  };
}

export const CASE_WORKFLOW_GROUPS = Object.freeze([
  {
    id: 'intake',
    title: 'Intake And Starting Main Transactions',
    defaultOpen: true,
    steps: [
      {
        tag: 'CASE_INTAKE',
        order: 10,
        title: 'Load starting main transactions',
        description: 'Put the starting transaction entries and any necessary To Addresses into the Main Data sheet.',
        checkIds: ['main_transactions'],
        actions: [
          workflowAction('load_starting_main_transactions', 'Load Starting Txns', { kind: 'starting-main-transactions', primary: true }),
          workflowAction('confirm_starting_main_transactions', 'Check / Confirm', { kind: 'starting-main-confirm' }),
       //  workflowAction('open_main_sheet', 'Open Main', { kind: 'sheet', target: 'main' }),
          workflowAction('seed_case_headers', 'Seed headers', { kind: 'scaffold' })
        ]
      },
      {
        tag: 'NETWORK_DISCOVERY',
        order: 20,
        title: 'Identify transaction networks',
        description: 'Look up Chain Id / Chain Name for main entries missing network data.',
        checkIds: ['networks'],
        actions: [
          workflowAction('lookup_networks_auto', 'Look Up Networks', { kind: 'network-discovery', primary: true, signalCode: WORKFLOW_SIGNAL_TRANSACTION_NETWORKS_IDENTIFIED }),
    //      workflowAction('open_main_sheet', 'Open Main', { kind: 'sheet', target: 'main' })
        ]
      },
      {
        tag: 'TRANSACTION_DATES',
        order: 30,
        title: 'Complete UTC dates and order main entries',
        description: 'Fill Column E with UTC dates for starting/main entries, then arrange main-entry blocks chronologically.',
        checkIds: ['dates', 'chronology'],
        signalCode: WORKFLOW_SIGNAL_MAIN_ENTRIES_DATED_AND_ORDERED,
        actions: [
          workflowAction('lookup_dates_auto', 'Look Up Dates', { kind: 'date-lookup', primary: true, signalCode: WORKFLOW_SIGNAL_TRANSACTION_DATES_FILLED }),
          workflowAction('sort_main_entries_by_date_auto', 'Sort By Date Before Labels', { kind: 'date-sort', emphasis: 'important', signalCode: WORKFLOW_SIGNAL_MAIN_ENTRIES_ORDERED_BY_DATE })
        ]
      },
      {
        tag: 'MAIN_TRANSACTION_PATH_LABELS',
        order: 40,
        title: 'Assign main transaction path labels',
        description: 'Populate Column A with standard whole-number labels for top-level main transaction entries before downstream pathing work.',
        checkIds: ['path_labels'],
        signalCode: WORKFLOW_SIGNAL_MAIN_TRANSACTION_PATH_LABELS_ASSIGNED,
        actions: [
          workflowAction('apply_main_path_labels_numeric_auto', 'Assign Number Labels', { kind: 'main-path-label-assignment', primary: true, signalCode: WORKFLOW_SIGNAL_MAIN_TRANSACTION_PATH_LABELS_ASSIGNED }),
       //   workflowAction('open_main_sheet', 'Open Main', { kind: 'sheet', target: 'main' })
        ]
      },
      {
        tag: 'CASE_CONTEXT_REVIEW',
        order: 50,
        title: 'Review case details and early narrative',
        description: 'Review available case details and confirm the starting transactions fit the early story.',
        checkIds: ['case_details'],
        signalCode: 'CASE_CONTEXT_REVIEWED',
        actions: [
          workflowAction('edit_case_details', 'Edit Details', { kind: 'case-details', primary: true }),
          workflowAction('record_case_context_reviewed', 'Record Review', { kind: 'signal', signalCode: 'CASE_CONTEXT_REVIEWED' })
        ]
      }
    ]
  },
  {
    id: 'raw-sapling',
    title: 'Raw Data And Graph Build',
    defaultOpen: false,
    steps: [
      {
        tag: 'RAW_DATA_FETCH',
        order: 60,
        title: 'Load raw data for main transactions',
        description: 'Put preserved fetched/imported rows into the separate Raw Data sheet. Saving raw data does not update Main Data by itself.',
        checkIds: ['raw_data'],
        signalCode: 'WAYFINDER_RAW_FETCH_SAVED',
        actions: [
          workflowAction('use_workspace_raw_import', 'Paste Raw Data', { kind: 'raw-data-import', primary: true, signalCode: 'WAYFINDER_RAW_FETCH_SAVED' }),
        //  workflowAction('open_raw_sheet', 'Open Raw', { kind: 'sheet', target: 'raw' }),
          workflowAction('request_wayfinder_raw_data', 'WayFinder Handoff', { kind: 'wayfinder-handoff', primary: false }),
        //    workflowAction('request_pathtracer_raw_data', 'PathTracer Request', { kind: 'raw-data-request-placeholder' })
        ]
      },
      {
        tag: 'RAW_TO_MAIN_PREPARATION',
        order: 70,
        title: 'Prepare raw data into main data',
        description: 'Process raw-backed starting transactions into investigator-facing main rows while keeping raw rows intact.',
        checkIds: ['raw_data', 'sapling_prepared'],
        signalCode: WORKFLOW_SIGNAL_TOOL_68_MAIN_DATA_PREPARED,
        actions: [
          workflowAction('prepare_raw_data_with_tool_68', 'Prepare Raw Data', { kind: 'tool68-preparation', primary: true, signalCode: WORKFLOW_SIGNAL_TOOL_68_MAIN_DATA_PREPARED }),
        //  workflowAction('open_raw_sheet', 'Open Raw', { kind: 'sheet', target: 'raw' }),
          workflowAction('open_output_sheet', 'Review Output', { kind: 'section', target: 'case-output' })
        ]
      }
    ]
  },
  {
    id: 'attribution-decisions',
    title: 'Attribution, Pruning, Grafting, And Bridges',
    defaultOpen: false,
    steps: [
      {
        tag: 'ADDRESS_ATTRIBUTION_FILL',
        order: 80,
        title: 'Fill address attribution in main data',
        description: 'Research From and To addresses in Main Data, then write attribution or Unknown into Column K.',
        checkIds: ['attribution'],
        signalCode: WORKFLOW_SIGNAL_TO_ADDRESS_ATTRIBUTION_APPLIED,
        actions: [
          workflowAction('open_case_attribution_fill_panel', 'Fill Attribution', { kind: 'address-attribution-fill', primary: true, signalCode: WORKFLOW_SIGNAL_TO_ADDRESS_ATTRIBUTION_APPLIED }),
    //      workflowAction('open_main_sheet', 'Open Main', { kind: 'sheet', target: 'main' })
        ]
      },
      {
        tag: 'ATTRIBUTION_PATH_OPERATIONS',
        order: 90,
        title: 'Review attributed rows and resolve path operations',
        description: 'Choose a qualified output row, then intentionally prune, graft, or Bridge graft the path in one staged workflow.',
        checkIds: ['path_decisions'],
        signalCode: WORKFLOW_SIGNAL_PATH_OPERATION_RESOLVED,
        actions: [
          workflowAction('open_path_operation_panel', 'Prune / Graft / Bridge', { kind: 'path-operation', primary: true, signalCode: WORKFLOW_SIGNAL_PATH_OPERATION_RESOLVED }),
       //   workflowAction('open_main_sheet', 'Open Main', { kind: 'sheet', target: 'main' })
        ]
      },
      {
        tag: 'ADDRESS_COLOR_LIKE_CELLS',
        order: 100,
        title: 'Color matching From/To addresses',
        description: 'Apply Color Like Cells-style highlighting to Main Data Column C and D address cells so repeated addresses are visually linked after pruning, grafting, and Bridge work. Re-run this after case data changes, or clear the colors if the palette is not useful.',
        checkIds: ['address_colors'],
        signalCode: WORKFLOW_SIGNAL_ADDRESS_FLOW_COLORS_APPLIED,
        signalRequiresCurrentRevision: true,
        actions: [
          workflowAction('color_case_address_cells', 'Color C/D Addresses', { kind: 'address-coloring', primary: true, signalCode: WORKFLOW_SIGNAL_ADDRESS_FLOW_COLORS_APPLIED }),
          workflowAction('clear_case_address_colors', 'Clear Colors', { kind: 'address-color-clear' }),
     //     workflowAction('open_main_sheet', 'Open Main', { kind: 'sheet', target: 'main' })
        ]
      },
      {
        tag: 'ENTITY_REVIEW',
        order: 110,
        title: 'Review new entities and update curators',
        description: 'Check newly surfaced entities and update curators or supporting records where appropriate.',
        checkIds: ['entity_review'],
        signalCode: WORKFLOW_SIGNAL_NEW_ENTITIES_REVIEWED,
        signalRequiresCurrentRevision: true,
        actions: [workflowAction('review_new_entities', 'Review Entities', { kind: 'entity-curator-review', primary: true, signalCode: WORKFLOW_SIGNAL_NEW_ENTITIES_REVIEWED })]
      },
      {
        tag: 'EXTERNAL_ATTRIBUTION_REVIEW',
        order: 120,
        title: 'Review addresses in external attribution tools',
        description: 'Use external attribution tooling as needed before finalizing prune/graft/bridge choices.',
        checkIds: ['external_review'],
        actions: [workflowAction('mark_external_attribution_reviewed', 'Mark External Review Done', { kind: 'signal', primary: true, signalCode: 'EXTERNAL_ATTRIBUTION_REVIEWED' })]
      }
    ]
  },
  {
    id: 'cleanup',
    title: 'Consistency, Notes, Legend, And Cleanup',
    defaultOpen: false,
    steps: [
      {
        tag: 'CASE_INCONSISTENCIES',
        order: 130,
        title: 'Review and resolve case inconsistencies',
        description: 'Review inconsistency cards, apply safe fixes, and resolve remaining judgement cards before report buildout.', // tool 71
        checkIds: ['case_inconsistencies'],
        signalCode: 'CASE_INCONSISTENCIES_REVIEWED',
        actions: [
          workflowAction('review_case_inconsistencies', 'Review Cards', { kind: 'inconsistency-review', primary: true, signalCode: 'CASE_INCONSISTENCIES_REVIEWED' }),
          workflowAction('run_checks', 'Run Checks', { kind: 'checks' })
        ]
      },
      {
        tag: 'NORMALIZE_DEPOSIT_NOTES',
        order: 140,
        title: 'Normalize deposit, hot-wallet, and unknown-service notes',
        description: 'Clean high-value note patterns and generic unknown-service path-ending markers without changing raw source rows.',
        checkIds: ['deposit_hot_wallet_notes'],
        signalCode: WORKFLOW_SIGNAL_DEPOSIT_HOT_WALLET_NOTES_NORMALIZED,
        actions: [workflowAction('normalize_deposit_hot_wallet_notes', 'Normalize Notes', { kind: 'deposit-hot-wallet-normalization', primary: true, signalCode: WORKFLOW_SIGNAL_DEPOSIT_HOT_WALLET_NOTES_NORMALIZED })]
      },
      {
        tag: 'HIGH_PRIORITY_DEPOSIT_PATTERNS',
        order: 150,
        title: 'Review high-priority deposit pattern candidates',
        description: 'Review high-priority deposit-pattern / early path-end candidates found by amount, timing, and path-link checks. Dismiss remaining candidates when the analyst has reviewed them.', // tool 78
        checkIds: ['deposit_patterns'],
        signalCode: WORKFLOW_SIGNAL_DEPOSIT_PATTERNS_REVIEWED,
        actions: [workflowAction('review_deposit_patterns', 'Review Patterns', { kind: 'deposit-pattern-review', primary: true, signalCode: WORKFLOW_SIGNAL_DEPOSIT_PATTERNS_REVIEWED })]
      },
      {
        tag: 'KNOWN_ENTITY_NOTE_CASING',
        order: 160,
        title: 'Review known-entity note casing',
        description: 'Review Column J mentions of known entities and fix only the safe casing differences before deliverable generation.',
        checkIds: ['known_entity_note_casing'],
        signalCode: WORKFLOW_SIGNAL_KNOWN_ENTITY_CASING_REVIEWED,
        actions: [
          workflowAction('review_known_entity_note_casing', 'Review Casing', { kind: 'known-entity-note-casing-review', primary: true, signalCode: WORKFLOW_SIGNAL_KNOWN_ENTITY_CASING_REVIEWED })
        ]
      },
      {
        tag: 'DUPLICATE_HASH_LABELS',
        order: 170,
        title: 'Label duplicate transaction hashes',
        description: 'Regenerate the current duplicate-hash map, refresh duplicate-hash notes in Column J, and expose the live Duplicate Hash Table deliverable.',
        checkIds: ['duplicate_hashes'],
        signalCode: WORKFLOW_SIGNAL_DUPLICATE_HASHES_LABELED,
        signalRequiresCurrentRevision: true,
        actions: [
          workflowAction('label_duplicate_hashes', 'Label Duplicates', { kind: 'duplicate-hash-labeler', primary: true, signalCode: WORKFLOW_SIGNAL_DUPLICATE_HASHES_LABELED }),
          workflowAction('open_duplicate_hash_deliverable', 'Open Duplicate Table', { kind: 'duplicate-hash-deliverable', target: 'duplicate_hash_table' }),
         // workflowAction('open_main_sheet', 'Open Main', { kind: 'sheet', target: 'main' })
        ]
      },
      {
        tag: 'NOTES_BACKUP_AND_HASH_REPLACEMENT',
        order: 180,
        title: 'Back up notes and replace hashes with path labels',
        description: 'Create/merge an original Column J notes backup, then refresh Continues/Branches note sections from transaction hashes to current path labels.',
        checkIds: ['notes_backup'],
        signalCode: WORKFLOW_SIGNAL_NOTE_HASH_PATH_LABEL_REWRITE_COMPLETE,
        signalRequiresCurrentRevision: true,
        actions: [
          workflowAction('backup_notes_replace_hashes', 'Rewrite Notes', { kind: 'note-hash-label-rewrite', primary: true, signalCode: WORKFLOW_SIGNAL_NOTE_HASH_PATH_LABEL_REWRITE_COMPLETE }),
          workflowAction('open_original_notes_backup', 'Stage Backup', { kind: 'original-notes-backup-deliverable', target: 'original_notes_backup' }),
         // workflowAction('open_main_sheet', 'Open Main', { kind: 'sheet', target: 'main' })
        ]
      },
      {
        tag: 'WWW_USD_REFERENCES',
        order: 185,
        title: 'Review top-level USD reference values',
        description: 'Fill and review Column H USD reference values on top-level main transaction entries before address legend and deliverable buildout. This keeps the later What Went Where valuation setup from forcing avoidable late case edits.',
        checkIds: ['www_usd_references'],
        signalCode: WORKFLOW_SIGNAL_WWW_USD_REFERENCES_REVIEWED,
        signalRequiresCurrentRevision: true,
        actions: [
          workflowAction('review_www_usd_references', 'Review USD Values', { kind: 'www-usd-reference-review', primary: true, signalCode: WORKFLOW_SIGNAL_WWW_USD_REFERENCES_REVIEWED }),
          workflowAction('stage_www_usd_reference_audit', 'Stage Audit', { kind: 'www-usd-reference-audit-stage' }),
    //     workflowAction('open_main_sheet', 'Open Main', { kind: 'sheet', target: 'main' })
        ]
      },
      {
        tag: 'ADDRESS_LEGEND',
        order: 190,
        title: 'Build and review the address legend',
        description: 'Build a separate per-case address legend from main rows and reviewed labels.',
        checkIds: ['address_legend'],
        signalCode: WORKFLOW_SIGNAL_ADDRESS_LEGEND_REVIEWED,
        signalRequiresCurrentRevision: true,
        actions: [
          workflowAction('build_address_legend', 'Build / Review Legend', { kind: 'address-legend-review', primary: true, signalCode: WORKFLOW_SIGNAL_ADDRESS_LEGEND_REVIEWED }),
          workflowAction('stage_address_legend', 'Stage Legend', { kind: 'address-legend-deliverable', target: 'address_legend' }),
       //   workflowAction('open_main_sheet', 'Open Main', { kind: 'sheet', target: 'main' })
        ]
      }
    ]
  },
  {
    id: 'deliverables',
    title: 'Deliverable Buildout And Shipping',
    defaultOpen: false,
    steps: [
      {
        tag: 'TEMPLATE_DELIVERABLE',
        order: 200,
        title: 'Build the template deliverable',
        description: 'Create and review the template deliverable from current case data, reviewed address legend, and effective curator.', // tool 31b
        checkIds: ['template_deliverable'],
        signalCode: WORKFLOW_SIGNAL_TEMPLATE_DELIVERABLE_REVIEWED,
        signalRequiresCurrentRevision: true,
        actions: [
          workflowAction('review_template_deliverable', 'Build / Review Template', { kind: 'template-deliverable-review', primary: true, signalCode: WORKFLOW_SIGNAL_TEMPLATE_DELIVERABLE_REVIEWED }),
          workflowAction('stage_template_deliverable', 'Stage Template', { kind: 'template-deliverable-stage', target: 'template' }),
          workflowAction('download_template_deliverable', 'Download TSV', { kind: 'template-deliverable-download', target: 'template' })
        ]
      },
      {
        tag: 'SUSPICIOUS_ADDRESS_TABLE',
        order: 210,
        title: 'Build the suspicious address table',
        description: 'Build and review the suspicious address concentration table from current Main Data and the reviewed Address Legend.', // tool 8f
        checkIds: ['suspicious_address_table'],
        signalCode: WORKFLOW_SIGNAL_SUSPICIOUS_ADDRESS_TABLE_REVIEWED,
        signalRequiresCurrentRevision: true,
        actions: [
          workflowAction('review_suspicious_address_table', 'Build / Review Table', { kind: 'suspicious-address-table-review', primary: true, signalCode: WORKFLOW_SIGNAL_SUSPICIOUS_ADDRESS_TABLE_REVIEWED }),
          workflowAction('stage_suspicious_address_table', 'Stage Table', { kind: 'suspicious-address-table-stage', target: 'suspicious_address_table' }),
          workflowAction('download_suspicious_address_table', 'Download TSV', { kind: 'suspicious-address-table-download', target: 'suspicious_address_table' })
        ]
      },
      {
        tag: 'EXCHANGE_ADDRESS_TABLE',
        order: 220,
        title: 'Build and review the exchange address table',
        description: 'Build and review the exchange address table from current Main Data and the reviewed Address Legend. Exclude rows that do not belong in this case table.', // Tool 9I-style 
        checkIds: ['exchange_address_table'],
        signalCode: WORKFLOW_SIGNAL_EXCHANGE_ADDRESS_TABLE_REVIEWED,
        signalRequiresCurrentRevision: true,
        actions: [
          workflowAction('review_exchange_address_table', 'Build / Review Table', { kind: 'exchange-address-table-review', primary: true, signalCode: WORKFLOW_SIGNAL_EXCHANGE_ADDRESS_TABLE_REVIEWED }),
          workflowAction('stage_exchange_address_table', 'Stage Table', { kind: 'exchange-address-table-stage', target: 'exchange_address_table' }),
          workflowAction('download_exchange_address_table', 'Download TSV', { kind: 'exchange-address-table-download', target: 'exchange_address_table' })
        ]
      },
      {
        tag: 'DORMANT_ADDRESS_DELIVERABLES',
        order: 230,
        title: 'Build dormant address deliverables',
        description: 'Build and review the clean dormant address table and the monitoring view from current Main Data and the reviewed Address Legend.', // Tool 52C-style
        checkIds: ['dormant_address_deliverables'],
        signalCode: WORKFLOW_SIGNAL_DORMANT_ADDRESS_DELIVERABLES_REVIEWED,
        signalRequiresCurrentRevision: true,
        actions: [
          workflowAction('review_dormant_address_deliverables', 'Build / Review Dormant', { kind: 'dormant-address-deliverable-review', primary: true, signalCode: WORKFLOW_SIGNAL_DORMANT_ADDRESS_DELIVERABLES_REVIEWED }),
          workflowAction('stage_dormant_address_table', 'Stage Clean Table', { kind: 'dormant-address-table-stage', target: 'dormant_address_table' }),
          workflowAction('stage_dormant_monitoring_view', 'Stage Monitoring', { kind: 'dormant-address-monitoring-stage', target: 'dormant_address_monitoring_view' }),
          workflowAction('download_dormant_address_table', 'Download Clean TSV', { kind: 'dormant-address-table-download', target: 'dormant_address_table' }),
          workflowAction('download_dormant_monitoring_view', 'Download Monitoring TSV', { kind: 'dormant-address-monitoring-download', target: 'dormant_address_monitoring_view' })
        ]
      },
      {
        tag: 'WHAT_WENT_WHERE',
        order: 240,
        title: 'Build and review What Went Where',
        description: 'Build and review the What Went Where deliverable and valuation audit from current Main Data. Column H USD reference setup normally happens earlier; the modal still includes the estimate/apply tools as a fallback.', // Tool 83-style 
        checkIds: ['what_went_where'],
        signalCode: WORKFLOW_SIGNAL_WHAT_WENT_WHERE_REVIEWED,
        signalRequiresCurrentRevision: true,
        actions: [
          workflowAction('review_what_went_where', 'Build / Review WWW', { kind: 'what-went-where-review', primary: true, signalCode: WORKFLOW_SIGNAL_WHAT_WENT_WHERE_REVIEWED }),
          workflowAction('stage_what_went_where', 'Stage WWW', { kind: 'what-went-where-stage', target: 'what_went_where' }),
          workflowAction('stage_what_went_where_audit', 'Stage Audit', { kind: 'what-went-where-audit-stage', target: 'what_went_where_valuation_audit' }),
          workflowAction('download_what_went_where', 'Download WWW TSV', { kind: 'what-went-where-download', target: 'what_went_where' })
        ]
      },
      {
        tag: 'CASE_CONCLUSION',
        order: 250,
        title: 'Build and review case conclusion',
        description: 'Build a written conclusion from reviewed What Went Where totals, then copy/stage/download and mark reviewed.',
        checkIds: ['case_conclusion'],
        signalCode: WORKFLOW_SIGNAL_CASE_CONCLUSION_REVIEWED,
        signalRequiresCurrentRevision: true,
        actions: [
          workflowAction('review_case_conclusion', 'Build / Review Conclusion', { kind: 'case-conclusion-review', primary: true, signalCode: WORKFLOW_SIGNAL_CASE_CONCLUSION_REVIEWED }),
          workflowAction('stage_case_conclusion', 'Stage Conclusion', { kind: 'case-conclusion-stage', target: 'conclusion' }),
          workflowAction('download_case_conclusion', 'Download TXT', { kind: 'case-conclusion-download', target: 'conclusion' })
        ]
      },
      {
        tag: 'REPORT_BODY',
        order: 260,
        title: 'Build and review report body',
        description: 'Build the report body from current Main Data and the reviewed address legend, then copy/stage/download the desired variant.', // Tool 38-style 
        checkIds: ['report_body'],
        signalCode: WORKFLOW_SIGNAL_REPORT_BODY_REVIEWED,
        signalRequiresCurrentRevision: true,
        actions: [
          workflowAction('review_report_body', 'Build / Review Body', { kind: 'report-body-review', primary: true, signalCode: WORKFLOW_SIGNAL_REPORT_BODY_REVIEWED }),
          workflowAction('copy_report_body_rich', 'Copy Rich', { kind: 'report-body-copy-rich', target: 'report_body' }),
          workflowAction('stage_report_body', 'Stage Body', { kind: 'report-body-stage', target: 'report_body' }),
          workflowAction('download_report_body', 'Download TXT', { kind: 'report-body-download', target: 'report_body' })
        ]
      },
      {
        tag: 'PATH_ENDING_ADDENDUM_REVIEW',
        order: 270,
        title: 'Review exchange path-ending rows for addendum',
        description: 'Run the exchange keyword filter against the current What Went Where path-ending output, inspect included/omitted rows, and stage candidate rows in Output before addendum build.', //  Tool 55-style 
        checkIds: ['addendum_path_endings'],
        signalCode: WORKFLOW_SIGNAL_PATH_ENDING_ROWS_REVIEWED,
        signalRequiresCurrentRevision: true,
        actions: [
          workflowAction('review_path_ending_rows', 'Review Rows', { kind: 'addendum-path-ending-review', primary: true, signalCode: WORKFLOW_SIGNAL_PATH_ENDING_ROWS_REVIEWED }),
          workflowAction('stage_addendum_path_ending_rows', 'Stage Candidates', { kind: 'addendum-path-ending-stage', target: 'addendum' }),
          workflowAction('stage_addendum_path_ending_audit', 'Stage Audit', { kind: 'addendum-path-ending-audit', target: 'addendum_audit' })
        ]
      },
      {
        tag: 'ADDENDUM_RECIPIENT_ENTITY',
        order: 280,
        title: 'Resolve recipient entity for addendum rows',
        description: 'Review of the addendum candidate rows: auto-resolve single-entity matches, choose the correct recipient when multiple exchanges matched, and stage the resolved rows to Output.', // Tool48-style 
        checkIds: ['addendum_recipient_entities'],
        signalCode: WORKFLOW_SIGNAL_ADDENDUM_RECIPIENTS_RESOLVED,
        signalRequiresCurrentRevision: true,
        actions: [
          workflowAction('resolve_addendum_recipient_entities', 'Resolve Entities', { kind: 'addendum-recipient-review', primary: true, signalCode: WORKFLOW_SIGNAL_ADDENDUM_RECIPIENTS_RESOLVED }),
          workflowAction('stage_addendum_recipient_entities', 'Stage Resolved Rows', { kind: 'addendum-recipient-stage', target: 'addendum' }),
          workflowAction('stage_addendum_recipient_audit', 'Stage Audit', { kind: 'addendum-recipient-audit', target: 'addendum_audit' })
        ]
      },
      {
        tag: 'ADDENDUM_BUILD',
        order: 290,
        title: 'Build and review addendum',
        description: 'Addendum build from reviewed path-ending rows and resolved recipient entities. Preview the formatted addendum, narrative, and audit before marking the addendum current.', // Tool18E-style
        checkIds: ['addendum_build'],
        signalCode: WORKFLOW_SIGNAL_ADDENDUM_REVIEWED,
        signalRequiresCurrentRevision: true,
        actions: [
          workflowAction('review_addendum_build', 'Build / Review', { kind: 'addendum-build-review', primary: true, signalCode: WORKFLOW_SIGNAL_ADDENDUM_REVIEWED }),
          workflowAction('stage_case_addendum', 'Stage Addendum', { kind: 'addendum-stage', target: 'addendum' }),
          workflowAction('stage_case_addendum_narrative', 'Stage Narrative', { kind: 'addendum-narrative-stage', target: 'addendum_narrative' }),
          workflowAction('stage_case_addendum_audit', 'Stage Audit', { kind: 'addendum-audit-stage', target: 'addendum_audit' }),
          workflowAction('copy_case_addendum_rich', 'Copy Rich', { kind: 'addendum-copy-rich', target: 'addendum' })
        ]
      },
      {
        tag: 'CASE_FLOW_VISUALS',
        order: 300,
        title: 'Create case flow visuals',
        description: 'Preview and export case flow visuals directly from Main Data and the reviewed address legend. Recommended cleanup is applied by default: labels, swap/bridge highlights, WayFinder-style merge, trunk wrapping, and overlap cleanup.', // Tool87-style 
        checkIds: ['case_flow_visuals'],
        signalCode: WORKFLOW_SIGNAL_CASE_FLOW_VISUALS_CREATED,
        signalRequiresCurrentRevision: true,
        actions: [
          workflowAction('review_case_flow_visuals', 'Preview / Download Visuals', { kind: 'case-flow-visuals-review', primary: true, signalCode: WORKFLOW_SIGNAL_CASE_FLOW_VISUALS_CREATED }),
          workflowAction('stage_case_flow_visuals_summary', 'Stage Summary', { kind: 'case-flow-visuals-stage-summary', target: 'case_flow_visuals' }),
          workflowAction('mark_case_flow_visuals_done', 'Mark Visuals Done', { kind: 'case-flow-visuals-done', signalCode: WORKFLOW_SIGNAL_CASE_FLOW_VISUALS_CREATED })
        ]
      },
      {
        tag: 'CASE_COMPLETION_SUMMARY',
        order: 310,
        title: 'Review completion summary and ship deliverables',
        description: 'Preview the completion summary and assemble the full one-click report package for copy or download.',
        checkIds: ['full_report_package'],
        signalCode: WORKFLOW_SIGNAL_FULL_REPORT_PACKAGE_REVIEWED,
        signalRequiresCurrentRevision: true,
        actions: [
          workflowAction('open_one_click_report_package', 'Review / Copy Package', { kind: 'full-report-package-review', primary: true, signalCode: WORKFLOW_SIGNAL_FULL_REPORT_PACKAGE_REVIEWED }),
          workflowAction('copy_one_click_report_package_rich', 'Copy Rich Package', { kind: 'full-report-package-copy-rich', target: 'one_click_report_package' }),
          workflowAction('download_one_click_report_package_html', 'Download HTML', { kind: 'full-report-package-download-html', target: 'one_click_report_package' })
        ]
      }
    ]
  }
]);

export const CASE_DELIVERABLE_GROUPS = Object.freeze([
  {
    id: 'case-data',
    title: 'Core Case Data',
    items: [
      { id: 'main_data_tsv', title: 'Main Data TSV', description: 'Current investigator-facing main case rows as TSV.', generator: 'main_tsv', requires: ['mainEntries'] },
      { id: 'raw_data_tsv', title: 'Raw Data TSV', description: 'Preserved raw/source rows as TSV.', generator: 'raw_tsv', requires: ['rawEntries'] },
      { id: 'duplicate_hash_table', title: 'Duplicate Hash Table', description: 'Current map of duplicate transaction hashes and the differing path labels they appear under.', generator: 'duplicate_hash_table', requires: ['mainEntries'] },
      { id: 'original_notes_backup', title: 'Original Notes Backup', description: 'Backup of original analyst notes before hash/path-label replacements.', generator: 'notes_backup', requires: ['mainEntries'] },
      { id: 'address_legend', title: 'Address Legend', description: 'Separate per-case address legend built from current rows and labels.', generator: 'address_legend_preview', requires: ['addresses'] }
    ]
  },
  {
    id: 'tables-audits',
    title: 'Tables And Audits',
    items: [
      { id: 'template', title: 'Template', description: 'Template spreadsheet built from current Main Data, reviewed address legend, and effective curator.', generator: 'case_template', requires: ['mainEntries', 'pathLabels', 'addressLegendReviewed'] },
      { id: 'suspicious_address_table', title: 'Suspicious Address Table', description: 'Concentration table for suspect-side addresses, deduped against duplicate transaction hashes.', generator: 'suspicious_address_table', requires: ['mainEntries', 'addressLegendReviewed'] },
      { id: 'exchange_address_table', title: 'Exchange Address Table', description: 'Table of exchange/service receiving addresses, deduped against duplicate transaction-output repeats and reviewable for row exclusions.', generator: 'exchange_address_table', requires: ['mainEntries', 'addressLegendReviewed'] },
      { id: 'dormant_address_table', title: 'Dormant Address Table', description: 'Clean dormant table with Address and Funds Followed only.', generator: 'dormant_address_table', requires: ['mainEntries', 'addressLegendReviewed'] },
      { id: 'dormant_address_monitoring_view', title: 'Dormant Address Monitoring View', description: 'Monitoring-oriented dormant address view with address, amount/token, funds followed, and related transaction hash.', generator: 'dormant_address_monitoring_view', requires: ['mainEntries', 'addressLegendReviewed'] },
      { id: 'what_went_where', title: 'What Went Where', description: 'Path-ending report section built from current Main Data and top-level Column H USD references.', generator: 'what_went_where', requires: ['mainEntries', 'pathLabels'] },
      { id: 'what_went_where_valuation_audit', title: 'What Went Where Valuation Audit', description: 'Valuation audit, category totals, manual review rows, and per-main coverage for What Went Where.', generator: 'what_went_where_valuation_audit', requires: ['mainEntries', 'pathLabels'] }
    ]
  },
  {
    id: 'narrative-report',
    title: 'Narrative Report',
    items: [
      { id: 'conclusion', title: 'Conclusion', description: 'Reviewed written case conclusion built from the reviewed What Went Where analysis.', generator: 'case_conclusion', requires: ['mainEntries', 'pathLabels'] },
      { id: 'report_body', title: 'Report Body', description: 'Standard rich/text report body built from current Main Data and the reviewed address legend.', generator: 'case_report_body', requires: ['mainEntries', 'pathLabels', 'addressLegendReviewed'] },
      { id: 'report_body_spacing_tags', title: 'Report Body With Custom Spacing Tags', description: 'Report body variant that preserves [[CUSTOM_SPACING]] tags for custom document spacing.', generator: 'case_report_body_spacing_tags', requires: ['mainEntries', 'pathLabels', 'addressLegendReviewed'] },
      { id: 'addendum', title: 'Addendum / Path Endings', description: 'Structured addendum for reviewed exchange path-ending rows.', generator: 'case_addendum', requires: ['addendumCanBuild'] },
      { id: 'addendum_audit', title: 'Addendum Audit', description: 'Audit view for addendum generation, source rows, recipient decisions, and omission/condensing notes.', generator: 'case_addendum_audit', requires: ['addendumCanBuild'] },
      { id: 'addendum_narrative', title: 'Addendum Narrative', description: 'Narrative addendum output grouped by resolved recipient entity.', generator: 'case_addendum_narrative', requires: ['addendumCanBuild'] }
    ]
  },
  {
    id: 'package',
    title: 'Final Package',
    items: [
      { id: 'case_flow_visuals', title: 'Case Flow Visuals', description: 'In-app SVG/PNG/JPG flow visual package generated from Main Data and the reviewed address legend.', generator: 'case_flow_visuals', requires: ['mainEntries'] },
      { id: 'case_completion_summary', title: 'Case Completion Summary', description: 'Final completion summary generated from current workflow and deliverable state.', generator: 'case_completion_summary', requires: ['mainEntries'] },
      { id: 'one_click_report_package', title: 'One-Click Output Report Package', description: 'Complete report package assembled from reviewed report body, addendum, and supporting deliverables.', generator: 'full_report_package', requires: ['mainEntries'] }
    ]
  }
]);
